import SpinningIcon from '../../Template/SpinningIcon'

export default SpinningIcon
